"use client";

import { createContext, useState, useContext, ReactNode } from 'react';

interface ProfilePhotoContextType {
  profilePhoto: string | undefined | null;
  setProfilePhoto: (photo: string | undefined | null) => void;
}

const ProfilePhotoContext = createContext<ProfilePhotoContextType | undefined>(undefined);

export const ProfilePhotoProvider = ({ children }: { children: ReactNode }) => {
  const [profilePhoto, setProfilePhoto] = useState<string | undefined | null>(undefined);

  return (
    <ProfilePhotoContext.Provider value={{ profilePhoto, setProfilePhoto }}>
      {children}
    </ProfilePhotoContext.Provider>
  );
}

export const useProfilePhoto = () => {
  const context = useContext(ProfilePhotoContext);
  if (context === undefined) {
    throw new Error('useProfilePhoto deve ser usado dentro de um ProfilePhotoProvider');
  }
  return context;
};

